import { EnumModel, EnumRecord } from "core/models/enum.model";

export enum ProductTypeEnum {
  PhysicalProduct = 1,
  Service = 2,
}

export const ProductType: EnumRecord<ProductTypeEnum, EnumModel> = {
  [ProductTypeEnum.PhysicalProduct]: { description: "کالای فیزیکی" },
  [ProductTypeEnum.Service]: { description: "خدمت" },
};
